import { t } from 'i18next'

import { Icon } from '@/components/icon'
import SelectPopover from '@/components/select-popover'
import { Button } from '@/components/ui'
import { type PersonType } from '@/features/proposta/brasil/domain/Comprador/opcoes-comprador-menu'

type TCadastrarCompradorButtonProps = {
  isEmpty: boolean
  opcoesCadastro: Array<{ id: PersonType; label: string }>
  onSelect: (value: PersonType) => void
  testId?: string
}

export const CadastrarCompradorButton = ({
  isEmpty,
  opcoesCadastro,
  onSelect,
  testId = 'btn-cadastrar-comprador',
}: TCadastrarCompradorButtonProps) => {
  return (
    <SelectPopover<PersonType>
      title={t('proposta:cadastro_compradores.popover.titulo')}
      options={opcoesCadastro}
      onSelect={onSelect}
      triggerButton={
        <Button variant={isEmpty ? 'default' : 'outline'} className="w-full md:w-auto" data-testid={testId}>
          <Icon name="plus" />
          {t(
            isEmpty
              ? 'proposta:cadastro_compradores.cadastrar_comprador'
              : 'proposta:cadastro_compradores.adicionar_novo',
          )}
        </Button>
      }
      className="w-full md:w-75"
    />
  )
}
